module.exports = __webpack_public_path__ + "assets/img/modelo_feed_com_logo.2bc6adcc.png";